import request from '@/utils/request'

export function getAdList() {
    return request({
        url: `/adverts`,
        method: 'get',
    })
}